import axios from "axios";
import { getAnalyticsPageViewUrl, getAnalyticsActionUrl, getMapDailyAnalyticsUrl } from "./ServiceUrls";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default class AnalyticsRepository {
    async sendPageView(pageName, anonymousUserId, mobileOS, additionalParameters = null) {
        const response = await axios.post(
            getAnalyticsPageViewUrl(),
            {
                pageName: pageName,
                extras: additionalParameters,
                anonymousUserId: anonymousUserId,
                os: mobileOS
            }
        );
        return response.data
    }

    async sendAction(actionName, pageName, anonymousUserId, mobileOS, additionalParameters = null) {
        const response = await axios.post(
            getAnalyticsActionUrl(),
            {
                actionName: actionName,
                pageName: pageName,
                extras: additionalParameters,
                anonymousUserId: anonymousUserId,
                os: mobileOS
            }
        );
        return response.data
    }

    async getMapDailyAnalytics(mapSlug) {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            getMapDailyAnalyticsUrl(mapSlug),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }
}